import React from 'react';
import { FormFieldsProps } from '../types';
import FormInput from './FormInput';

const FormFields: React.FC<FormFieldsProps> = ({
  isRegister,
  formData,
  onInputChange,
}) => {
  return (
    <div className="flex flex-col gap-3">
      {isRegister && (
        <div className="flex flex-col lg:flex-row gap-3 w-full">
          <div className="flex-1">
            <FormInput
              id="firstName"
              type="text"
              label="First Name"
              placeholder="Enter your first name"
              onChange={(e) => onInputChange('firstName', e.target.value)}
              value={formData.firstName}
            />
          </div>
          
          <div className="flex-1">
            <FormInput
              id="lastName"
              type="text"
              label="Last Name"
              placeholder="Enter your last name"
              onChange={(e) => onInputChange('lastName', e.target.value)}
              value={formData.lastName}
            />    
          </div>
          
        </div>
      )}

      <FormInput
        id="username"
        type="text"
        label="Username"
        placeholder="Enter your username"
        onChange={(e) => onInputChange('username', e.target.value)}
        value={formData.username}
      />

      <FormInput
        id="password"
        type="password"
        label="Password"
        placeholder="Enter your password"
        onChange={(e) => onInputChange('password', e.target.value)}
        value={formData.password}
      />

      {isRegister && (
        <FormInput
          id="confirmPassword"
          type="password"
          label="Confirm Password"
          placeholder="Confirm your password"
          onChange={(e) => onInputChange('confirmPassword', e.target.value)}
          value={formData.confirmPassword}
        />
      )}
    </div>
  );
};

export default FormFields;
